// Column-tabanli Excel (.xlsx) indirme — downloadCSV ile ayni imza.
// Fark: sayilar gercek sayi hucresi olarak yazilir (formul/toplam calisir),
// sutun genislikleri icerige gore ayarlanir, ilk satir kalin baslik.
import * as XLSX from 'xlsx';

export const downloadXLSX = (rows, columns, filename, sheetName = 'Rapor') => {
  const aoa = [
    columns.map((c) => c.label),
    ...rows.map((r) => columns.map((c) => {
      const v = c.value(r);
      return v == null ? '' : v;
    })),
  ];
  const ws = XLSX.utils.aoa_to_sheet(aoa);
  ws['!cols'] = columns.map((c, i) => ({
    wch: Math.min(
      50,
      Math.max(String(c.label).length, ...aoa.slice(1).map((row) => String(row[i] ?? '').length), 8) + 2,
    ),
  }));
  ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 0, c: 0 }, e: { r: aoa.length - 1, c: columns.length - 1 } }) };
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName.slice(0, 31));
  XLSX.writeFile(wb, filename);
};
